import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Validation extends Vue {
  /**
   * @param  {number} length , Maximum length allowed
   * @param  {string} errorTextKey , If length is greater than expected length returns error message mapped to errorTextKey.
   */
  maxLengthRule(length: number, errorTextKey: string): (v: string) => boolean | string {
    return v => !v || v.trim().length <= length || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * @param  {number} regexpStr , Regex
   * @param  {string} errorTextKey , If value contains element of the regex returns error message mapped to errorTextKey.
   */
  regexpRule(regexpStr: string, errorTextKey: string): (v: string) => boolean | string {
    return v => RegExp(regexpStr).test(v) || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * @param  {string} errorTextKey , If value is null returns the error message mapped to errorTextKey
   */
  requiredRule(errorTextKey: string): (v: number | string) => boolean | string {
    return v => !!v || v === 0 || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * @param  {number} from , minimum range
   * @param  {number} to , maximum range , Error will be thrown if input field is not within the range
   */
  range(minimal: number, maximal: number, errorTextKey: string): (v: string) => boolean | string {
    return v => (Number(v) >= minimal && Number(v) <= maximal) || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * @param  {number} from , minimum range
   * @param  {number} exclude , exclude this number in range
   * @param  {number} to , maximum range , Error will be thrown if input field is not within the range
   */
  rangeExclude(minimal: number, exclude: number, maximal: number, errorTextKey: string): (v: string) => boolean | string {
    return v => (Number(v) >= minimal && Number(v) <= maximal && Number(v) !== exclude) || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * Excludes a single value
   * @param  {number} value , Value to exclude
   */
  valueExclude(value: number, errorTextKey: string): (v: string) => boolean | string {
    return v => Number(v) !== value || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * Check if number is unique in provided list
   * @param  {number[]} inside , List of values to parse
   */
  isUniqueNumber(inside: number[], errorTextKey: string): (v: string) => boolean | string {
    return v => !inside.includes(Number(v)) || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * Check if string is unique in provided list
   * @param  {string[]} inside , List of values to parse
   */
  isUniqueString(inside: string[], errorTextKey: string): (v: string) => boolean | string {
    return v => !inside.includes((v)) || this.$i18n.t(errorTextKey).toString();
  }

  /**
   * Check if file size is correct
   * @param  {Number} size , The file to check
   */
  maxFileSize(size: number, errorTextKey: string): (v: File) => boolean | string {
    return v => !v || v.size < size || this.$i18n.t(errorTextKey).toString();
  }
}
